import Rest from '../services/rest'
import {store} from '../store/store'

/**
 * @typedef {LiberacaoService}
 */
export default class LiberacaoService{

    constructor() {
        this.resource = "/financeiro/liberacaocredito"

        this.http = Rest.build(store.getters.token, this.resource);
    }

    static build() {
        return new this();
    }

    get_all(status='cotacao_atualizada'){       
        return this.http.get(`/status/${status}`);
    }

    liberar_periodo(params){
        return this.http.post('/save', params)
    }


}